import _ from "lodash";
import vm from "../main";
import { httpClient as http } from "../services";

const internals = {};

internals.addSurveys = (surveys) => {
  surveys = Object.assign({}, surveys);
 
  const promises = [];
  return http
    .post("/survey/create", {
      cityId: surveys.cityId,
      wcaId: surveys.wcaId,
      wdaId: surveys.wdaId,
      surveyorId: surveys.surveyorId,
      lineTower: surveys.lineTower,
      startDate: surveys.startDate,
      endDate: surveys.endDate,
    })
    .then((result) => {
      surveys = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("surveys.create-error:\n", error);
      throw error;
    });
};

internals.updateSurveys = (_id, surveys) => {
  
  return http
    .put(`/survey/update`, {
      _id: surveys._id,
      cityId: surveys.cityId,
      wcaId: surveys.wcaId,
      wdaId: surveys.wdaId,
      surveyorId: surveys.surveyorId,
      lineTower: surveys.lineTower,
      status: surveys.status,
      startDate: surveys.startDate,
      endDate: surveys.endDate,
    })
    .then((result) => {
      surveys = result.data;
      return surveys;
    })
    .catch((error) => {
      console.error("surveys.updateVehicle-error:\n", error);
      throw error;
    });
};

internals.getSurveyoysList = (Id) => {
  return http
    .get(`/register/surveyor/list?cityId=${Id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.getWasteCollectionAreaList = (Id) => {
  return http
    .get(`/waste-collection-area-list`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.getCollectionDivisionList = (Id) => {
  return http
    .get(`/waste-divisions/by-collection-id?_id=${Id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};
internals.getLineAndTowerList = (Id) => {
  return http
    .post(`/line-tower/byId`, {
      _ids: Id,
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("wasteCollectionService-error:\n", error);
      throw error;
    });
};

internals.getSurveysList = () => {
  return http
    .get(`/survey/list`)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("surveys.list-error:\n", error);
      throw error;
    });
};

internals.getById = (_id) => {
  return http
    .get(`/survey/ById?_id=${_id}`)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("surveys.Get-error:\n", error);
      throw error;
    });
};

internals.getSurveyById = (_id) => {
  return http
    .get(
      `/surveyDetail/byId?surveyId=${_id}`
    )
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("surveys.Get-error:\n", error);
      throw error;
    });
};


internals.getHousesBySurveyId = (_id, params) => {
  return http
    .get(
      `/houseListBySurveyId?page=${params.page}&limit=${params.limit}&id=${_id}&sortBy=${params.sortBy}&sortOrder=${params.sortOrder}&searchString=${params.searchString}`
    )
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("surveys.Get-error:\n", error);
      throw error;
    });
};

internals.getWasteCollectionAreaList = Id => {
  return http
    .get(`/waste-collection-area-list?cityId=${Id}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('surveyService-error:\n', error)
      throw error
    })
}


internals.getAllHousesBySurveyId = Id => {
  return http
    .get(`/houseList/surveyId/geoloc?id=${Id}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('surveyService-error:\n', error)
      throw error
    })
}




export default internals;



// WEBPACK FOOTER //
// ./src/services/surveys.service.js